import { StarterKit } from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extension-placeholder';
import { type EditorOptions, useEditor } from '@tiptap/react';

export const useInstructionEditor = (options: Partial<EditorOptions>) => {
  const { content, ...rest } = options;

  return useEditor(
    {
      content: content,
      autofocus: false,
      immediatelyRender: true,
      onCreate: (ctx) => {
        ctx.editor.commands.setContent(content ?? '');
      },
      extensions: [
        StarterKit.configure({
          bold: false,
          code: false,
          italic: false,
          strike: false,
          heading: false,
          listItem: false,
          codeBlock: false,
          gapcursor: false,
          hardBreak: false,
          bulletList: false,
          blockquote: false,
          dropcursor: false,
          orderedList: false,
          horizontalRule: false,
        }),
        Placeholder.configure({
          placeholder: 'Your instructions here',
        }),
      ],
      ...rest,
    },
    []
  );
};
